import { loadView } from '@/router'

export default [
  {
    path: 'budgets',
    name: 'sales-budgets',
    component: loadView('Application/Sales/Budgets'),
    redirect: {
      name: 'sales-budgets-list'
    },
    children: [
      {
        path: 'list',
        name: 'sales-budgets-list',
        component: loadView('Application/Sales/Budgets/List')
      }
    ]
  }
]
